// src/components/customers/tabs/tabs-OrderSchedule.jsx
import React from "react";
export default function OrderScheduleTab() {
  return <div className="oc-empty">No schedule</div>;
}

